
    <template>
      <section class="content element-doc">
        <h2>Button 按钮</h2>
<p>常用的操作按钮。</p>
<h3>基本用法</h3>
<p>普通的button按钮。</p>
<demo-block>
        
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;apex-button type=&quot;primary&quot; @click=&quot;handleClick&quot;&gt;普通按钮&lt;/apex-button&gt;

&lt;script&gt;
  export default {
    methods: {
      handleClick() {
        this.$message.success('点击了普通按钮')
      }
    }
  };
&lt;/script&gt;
</code></pre></template></demo-block><h3>节流</h3>
<p>禁止用户频繁点击，多用于频繁点击操作，500ms之内重复点击只会执行一次。</p>
<demo-block>
        <div><p>给<code>apex-button</code>加上<code>throttle</code>属性即可开启节流。</p>
</div>
        <template slot="source"><element-demo1 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;apex-button type=&quot;primary&quot; throttle @click=&quot;handleClick&quot;&gt;throttle&lt;/apex-button&gt;

&lt;script&gt;
  export default {
    methods: {
      handleClick() {
        this.$message.success('点击了throttle按钮')
      }
    }
  };
&lt;/script&gt;
</code></pre></template></demo-block><h3>自动loading</h3>
<p>自动添加loading效果,方便点击处理事件,会通过参数 done 函数待 ajax等返回后控制loading关闭。</p>
<demo-block>
        <div><p>给<code>apex-button</code>加上<code>auto-loading</code>属性即可开启自动loading，传入<code>auto-fullscreen-loading</code>可开启自动全屏loading。</p>
</div>
        <template slot="source"><element-demo2 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;apex-button auto-loading @click=&quot;handleClick&quot; type=&quot;success&quot;&gt;自动loading&lt;/apex-button&gt;
&lt;apex-button auto-fullscreen-loading @click=&quot;handleClick&quot; type=&quot;warning&quot;&gt;全屏loading&lt;/apex-button&gt;

&lt;script&gt;
export default {
  data () {
    return {
      fullscreenLoading: false
    }
  },
  methods: {
    handleClick(done) {
      setTimeout(() =&gt; {
        // do something
        done()  // done控制loading关闭
      }, 1000)
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h3>操作确认</h3>
<p>有时候我们点击按钮需弹窗确认后方可继续，apex-button 封装了这个步骤。</p>
<demo-block>
        <div><p>设置<code>confirm-type</code>属性为<code>pop</code>即可开弹出 Popconfirm 气泡确认框，设置<code>confirm-type</code>属性为<code>confirm</code>即可开弹出 MessageBox 弹框。确认的回调函数用 confirm 控制。</p>
</div>
        <template slot="source"><element-demo3 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;apex-button confirm-type=&quot;pop&quot; type=&quot;primary&quot; @confirm=&quot;confirm&quot; auto-fullscreen-loading &gt;删除&lt;/apex-button&gt;
&lt;apex-button confirm-type=&quot;confirm&quot; type=&quot;danger&quot; @confirm=&quot;confirm&quot; auto-fullscreen-loading &gt;删除&lt;/apex-button&gt;

&lt;script&gt;
export default {
  methods: {
    confirm (done) {
      setTimeout(() =&gt; {
        done()
      }, 1000)
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h3>tip button</h3>
<p>apex-tip-button 用于给按钮添加 tip 说明,包含 apex-button 的所有功能。</p>
<demo-block>
        
        <template slot="source"><element-demo4 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;apex-tip-button content=&quot;设置&quot; icon=&quot;el-icon-s-tools&quot; circle&gt;&lt;/apex-tip-button&gt;
&lt;apex-tip-button content=&quot;删除&quot; type=&quot;primary&quot; confirm-type=&quot;confirm&quot; @confirm=&quot;confirm&quot; auto-fullscreen-loading &gt;删除&lt;/apex-tip-button&gt;
&lt;apex-tip-button content=&quot;删除&quot; type=&quot;primary&quot; confirm-type=&quot;confirm&quot; @confirm=&quot;confirm&quot; auto-fullscreen-loading icon=&quot;el-icon-delete&quot; circle&gt;&lt;/apex-tip-button&gt;

&lt;script&gt;
export default {
  methods: {
    confirm (done) {
      setTimeout(() =&gt; {
        done()
      }, 1000)
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h3>Attributes</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>throttle</td>
<td>是否启用节流</td>
<td>boolean</td>
<td>—</td>
<td>false</td>
</tr>
<tr>
<td>autoLoading</td>
<td>点击后自动开启loading(按钮上)</td>
<td>boolean</td>
<td>—</td>
<td>false</td>
</tr>
<tr>
<td>autoFullscreenLoading</td>
<td>点击后自动开启loading(全屏)</td>
<td>boolean</td>
<td>—</td>
<td>false</td>
</tr>
<tr>
<td>confirmType</td>
<td>操作按钮确认方式,可自动渲染el-popconfirm或element-ui的confirm弹窗</td>
<td>String</td>
<td>pop/confirm</td>
<td>—</td>
</tr>
<tr>
<td>popConfig</td>
<td>当传入confirmType为pop时,el-popconfirm属性的对象,可传入el-popconfirm组件支持的所有属性值</td>
<td>object</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>confirmConfig</td>
<td>当传入confirmType为confirm时,element-ui的Messagebox.confirm的属性值对象</td>
<td>—</td>
<td>—</td>
<td>—</td>
</tr>
</tbody>
</table>
<div class="tip">
<p>提示：除以上列出的为本组件封装的新属性,其他<code>el-input</code>的任何属性均可直接继承。</p>
</div>
<h3>Events</h3>
<table>
<thead>
<tr>
<th>事件名称</th>
<th>说明</th>
<th>回调参数</th>
</tr>
</thead>
<tbody>
<tr>
<td>click</td>
<td>点击事件,如使用了loading,可用回调函数done来清除loading</td>
<td>(fn:done)</td>
</tr>
<tr>
<td>confirm</td>
<td>当传入confirmType的时候,操作按钮确认事件</td>
<td>(fn:done)</td>
</tr>
</tbody>
</table>

      </section>
    </template>
    <script>
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('apex-button',{attrs:{"type":"primary"},on:{"click":_vm.handleClick}},[_vm._v("普通按钮")])],1)}
var staticRenderFns = []

  
    const democomponentExport = {
    methods: {
      handleClick() {
        this.$message.success('点击了普通按钮')
      }
    }
  };
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo1": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('apex-button',{attrs:{"type":"primary","throttle":""},on:{"click":_vm.handleClick}},[_vm._v("throttle")])],1)}
var staticRenderFns = []

  
    const democomponentExport = {
    methods: {
      handleClick() {
        this.$message.success('点击了throttle按钮')
      }
    }
  };
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo2": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('apex-button',{attrs:{"auto-loading":"","type":"success"},on:{"click":_vm.handleClick}},[_vm._v("自动loading")]),_vm._v(" "),_c('apex-button',{attrs:{"auto-fullscreen-loading":"","type":"warning"},on:{"click":_vm.handleClick}},[_vm._v("全屏loading")])],1)}
var staticRenderFns = []

  
    const democomponentExport = {
  data () {
    return {
      fullscreenLoading: false
    }
  },
  methods: {
    handleClick(done) {
      setTimeout(() => {
        // do something
        done()  // done控制loading关闭
      }, 1000)
    }
  }
}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo3": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('apex-button',{attrs:{"confirm-type":"pop","type":"primary","auto-fullscreen-loading":""},on:{"confirm":_vm.confirm}},[_vm._v("删除")]),_vm._v(" "),_c('apex-button',{attrs:{"confirm-type":"confirm","type":"danger","auto-fullscreen-loading":""},on:{"confirm":_vm.confirm}},[_vm._v("删除")])],1)}
var staticRenderFns = []

  
    const democomponentExport = {
  methods: {
    confirm (done) {
      setTimeout(() => {
        done()
      }, 1000)
    }
  }
}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo4": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('apex-tip-button',{attrs:{"content":"设置","icon":"el-icon-s-tools","circle":""}}),_vm._v(" "),_c('apex-tip-button',{attrs:{"content":"删除","type":"primary","confirm-type":"confirm","auto-fullscreen-loading":""},on:{"confirm":_vm.confirm}},[_vm._v("删除")]),_vm._v(" "),_c('apex-tip-button',{attrs:{"content":"删除","type":"primary","confirm-type":"confirm","auto-fullscreen-loading":"","icon":"el-icon-delete","circle":""},on:{"confirm":_vm.confirm}})],1)}
var staticRenderFns = []

  
    const democomponentExport = {
  methods: {
    confirm (done) {
      setTimeout(() => {
        done()
      }, 1000)
    }
  }
}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  